
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class SieveSizeMappingDialog extends _Ext.DialogBase<SieveSizeMappingRow, any> {
        protected getFormKey() { return SieveSizeMappingForm.formKey; }
        protected getIdProperty() { return SieveSizeMappingRow.idProperty; }
        protected getLocalTextPrefix() { return SieveSizeMappingRow.localTextPrefix; }
        protected getService() { return SieveSizeMappingService.baseUrl; }
        protected getDeletePermission() { return SieveSizeMappingRow.deletePermission; }
        protected getInsertPermission() { return SieveSizeMappingRow.insertPermission; }
        protected getUpdatePermission() { return SieveSizeMappingRow.updatePermission; }
        protected useViewMode() { return true; }
        protected get_ExtDialogOptions() {
            let options = super.get_ExtDialogOptions();
            options.ShowSaveAndNewButtonInToolbar = true;
            options.AutoFitContentArea = false;
            return options;
        }
        protected form = new SieveSizeMappingForm(this.idPrefix);

        constructor() {
            super();
            this.form.ProductTypeId.value ==  "12" ? q.showAndSetRequiredField(this.form.SubCategoryId):  q.showAndDisableField(this.form.SubCategoryId);

            this.form.ProductTypeId.changeSelect2(e => {
                if (this.form.ProductTypeId.value == "12")
                    q.showAndSetRequiredField(this.form.SubCategoryId);
                else
                    q.showAndDisableField(this.form.SubCategoryId);
            })

        }

    }
}